"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAllowedHtmlTags = exports.defaultToolbarButtonsXS = exports.defaultToolbarButtonsSM = exports.defaultToolbarButtons = void 0;
var defaultToolbarButtons = {
  moreText: {
    buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "clearFormatting"],
    align: "left",
    buttonsVisible: 3
  },
  moreParagraph: {
    buttons: ["alignLeft", "alignCenter", "paragraphFormat", "formatOL", "formatUL", "alignRight", "alignJustify", "lineHeight", "outdent", "indent", "quote", "cpQuote", "insertAbbr", "cpLang"],
    align: "left",
    buttonsVisible: 5
  },
  moreRich: {
    buttons: ["insertLink", "insertImage", "insertTable", "insertVideo", "embedly", "specialCharacters", "emoticons", "insertHR"],
    align: "left",
    buttonsVisible: 3
  },
  moreMisc: {
    buttons: ["undo", "redo", "html", "fullscreen", "print", "selectAll", "help"],
    align: "right",
    buttonsVisible: 4
  }
};
exports.defaultToolbarButtons = defaultToolbarButtons;
var defaultToolbarButtonsSM = {
  moreText: {
    buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "clearFormatting", "cpQuote", "insertAbbr", "cpLang"],
    align: "left",
    buttonsVisible: 2
  },
  moreParagraph: {
    buttons: ["alignLeft", "alignCenter", "paragraphFormat", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "lineHeight", "outdent", "indent", "quote"],
    align: "left",
    buttonsVisible: 2
  },
  moreRich: {
    buttons: ["insertLink", "insertImage", "insertFile", "insertTable", "insertVideo", "embedly", "specialCharacters", "emoticons", "insertHR"],
    align: "left",
    buttonsVisible: 2
  },
  moreMisc: {
    buttons: ["undo", "redo", "html", "fullscreen", "print", "selectAll", "help"],
    align: "right",
    buttonsVisible: 2
  }
};
exports.defaultToolbarButtonsSM = defaultToolbarButtonsSM;
var defaultToolbarButtonsXS = {
  moreText: {
    buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "clearFormatting", "cpQuote", "insertAbbr", "cpLang"],
    align: "left",
    buttonsVisible: 0
  },
  moreParagraph: {
    buttons: ["alignLeft", "alignCenter", "paragraphFormat", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "lineHeight", "outdent", "indent", "quote"],
    align: "left",
    buttonsVisible: 0
  },
  moreRich: {
    buttons: ["insertLink", "insertImage", "insertFile", "insertTable", "insertVideo", "embedly", "specialCharacters", "emoticons", "insertHR"],
    align: "left",
    buttonsVisible: 0
  },
  moreMisc: {
    buttons: ["undo", "redo", "html", "fullscreen", "print", "selectAll", "help"],
    align: "right",
    buttonsVisible: 2
  }
};
exports.defaultToolbarButtonsXS = defaultToolbarButtonsXS;
var defaultAllowedHtmlTags = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "pre", "progress", "q", "queue", "rp", "rt", "ruby", "s", "samp", "script", "style", "section", "select", "small", "source", "span", "strike", "strong", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"];
exports.defaultAllowedHtmlTags = defaultAllowedHtmlTags;